import React, { Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import store from './redux/store';
import { defineCustomElements, addTheme } from '@scania/components';
import { theme as scania } from '@scania/theme-light';
import { MsalProvider } from '@azure/msal-react';
import { msalInstance } from './authConfig';
import './register-webcomponents';
import App from './App';
import './i18n';
import '@scania/tegel/dist/tegel/tegel.css';

const container = document.getElementById('root');
const root = createRoot(container!);
root.render(
  <Suspense fallback={<div>Loading... </div>}>
    <React.StrictMode>
      <MsalProvider instance={msalInstance}>
        <Provider store={store}>
        <App />
        </Provider>
      </MsalProvider>
    </React.StrictMode>
  </Suspense>);

defineCustomElements();
addTheme(scania);
